import logo from './logo.svg';
import './ChatApp.css';
import React, { useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
function ChaApp( { token, userData }) {

  const [ socket, setSocket ] = useState(null);
  const [ applications, setApplications ] = useState([]);
  const [ selectedApp, setSelectedApp ] = useState('');
  const [appCode, setAppCode] = useState('');
  const [room, setRoom] = useState('');
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [user, setUser] = useState('');
  const [ typingUser, setTypingUser ] = useState('');
  const messageEndRef = useRef(null); // Referencia al último mensaje


  // Codigo para que no se dupliquen los mensajes
  useEffect(() => {
    setUser(userData.username);

    // Recuperar estado de la sala al recargar la página

    const storedAppCode = localStorage.getItem('appCode');
    const storedRoom = localStorage.getItem('room');

    if (storedAppCode && storedRoom) {
      setAppCode(storedAppCode);
      setRoom(storedRoom);
    }

    const newSocket = io(SOCKET_URL, {
      auth: {token}
    });
    newSocket.on('chat_history', (messages) => {
      setMessages(messages);
    });

    newSocket.on('receive_message', (data) => {
      setMessages((prevMessages) => [...prevMessages, { type: 'message', ...data }]);
    });

    newSocket.on('user_notification', (data) => {
      setMessages((prevMessages) => [...prevMessages, { type: 'notification', ...data }]);
    });

    newSocket.on('error_message', (error) => {
      console.error('Server error:', error);
    });
    newSocket.on('user_typing', ({user, appCode, appRoom}) => {
      if (user){
        setTypingUser(user);
        // console.log("Se esta recibiendo el evento de typing en el cliente correctamente, por el usuario ", user);
        // console.log(`${user} está escribiendo...`);
      } else {
        // console.log("No se esta recibiendo el evento de typing en el cliente correctamente");
        setTypingUser(null);
      }
      // Clear the typing user after 2 seconds
      setTimeout(() => {
        setTypingUser(null);
      }, 2000);
    });
    newSocket.on('messages_read', ({ user, messageIds }) => {
      setMessages((prevMessages) =>
        prevMessages.map((msg) =>
          messageIds.includes(msg._id) ? { ...msg, readBy: [...msg.readBy, user] } : msg
        )
      );
    });

    setSocket(newSocket);
    // Reconectar automaticamente si hay estado almacenado

    if (storedAppCode && storedRoom) {
      newSocket.emit('join_room', { appCode: storedAppCode, appRoom: `${storedAppCode}-${storedRoom}`, room: storedRoom, user: userData.username });
    }


    return () => {
      newSocket.off('chat_history');
      newSocket.off('receive_message');
      newSocket.off('user_typing');
      newSocket.off('user_notification');
      newSocket.off('error_message');
      newSocket.off('messages_read');
    };
  }, [
    token,
    userData,
  ]);

  useEffect(() => {
    console.log("Este es el UseEffect de messages")
    console.log(messageEndRef.current, "Este es el mensaje");
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: 'smooth' });
      console.log("Se esta haciendo scroll")
    }
  }, [messages]);

  // Hacer fetch de las aplicaciones registradas

  useEffect(() => {
    fetch(`${SOCKET_URL}/api/applications`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.json())
    .then((data) => {
      // console.log('Aplicaciones registradas:', data);
      setApplications(data);
    })
    .catch((err) => {
      console.error('Error al obtener las aplicaciones registradas:', err);
    });
  }, [
    token,
  ]);

  const joinRoom = () => {
   
    if (appCode === '' || room === '' || user === '') {
      console.error('App code, room, and user are required');
      return;
    }

    const appRoom = `${appCode}-${room}`;
    if (room !== '' && user !== '') { 
      socket.emit('join_room', { appCode, appRoom, room, user: userData.username});
    }
    // Guardar estado de la sala en localStorage
    localStorage.setItem('appCode', appCode);
    localStorage.setItem('room', room);
  }

  const leaveRoom = () => {
    const appRoom = `${appCode}-${room}`;
    if (room !== '' && user !== '') {
      socket.emit('leave_room', { room, appCode,appRoom,  user: userData.username });
      setRoom('');
      setMessages([]);
      setUser('');
      localStorage.removeItem('appCode');
      localStorage.removeItem('room');
    }
  }
  const sendMessage = () => {
    if (message !== '' && room !== '' && user !== '' && appCode !== '') {
      socket.emit('send_message', { appCode, room, message, user: userData.username });
      setMessage('');
    }
  }
  let typingTimeout = null;
  const handleTyping = () => {
    // console.log("SE ESTA ESCRIBIENDO MI GENTE")
    if (room !== '' && user !== '') {
      if (!typingTimeout) {
        socket.emit('typing', {appCode, room, user: userData.username });
        // console.log('Emitting typing event');
      }
    }
    clearTimeout(typingTimeout);
    typingTimeout = setTimeout(() => {
      typingTimeout = null;
    }, 2000);
  }

  const handleScroll = (e) => {
    const container = e.target;
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const containerHeight = container.clientHeight;
  
    if (scrollTop + containerHeight >= scrollHeight) {
      // Detectar qué mensajes están visibles

      const unreadMessages = messages.filter(
        (msg) => msg._id && !msg.readBy?.includes(user) // Solo mensajes no leídos
      )

      if (unreadMessages.length === 0) {
        console.log('All messages are read');
        return;
      }

      const messageIds = unreadMessages.map((msg) => msg._id);
  
      // Enviar estado de "leído" al backend
      socket.emit('mark_read', { appCode, room, user, messageIds });
    }
  };
  
  const formatDate = (timestamp) => {

    const date = new Date(timestamp);
    return date.toLocaleString();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  }

  return (
    <div className="chat-container">
      <h1>MS-SOCKET-CHAT</h1>
      <p>¡Bienvenido, {userData?.name}{userData?.lastname}!</p>
      <div className="join-section">
      <div>
        {Array.isArray(applications) ? (
          applications.length > 0 ? (
            <>
              <label htmlFor="applications">Seleccionar aplicación:</label>
              <select 
                id="applications"
                value={selectedApp}
                onChange={(e) => {
                  setSelectedApp(e.target.value);
                  setAppCode(e.target.value);
                }}
              >
                <option value="">Ninguna seleccionada</option>
                {applications.map((app) => (
                  <option key={app._id} value={app.appCode}>
                    {app.appCode}
                  </option>
                ))}
              </select>
            </>
          ) : (
            <p>Ninguna aplicación seleccionada.</p>
          )
        ) : (
          <p>Cargando aplicaciones...</p>
        )}
      </div>
        <input
          type="text"
          placeholder="Sala"
          className="input-field"
          onChange={(e) => setRoom(e.target.value)}
        />
        <button className="btn-primary" onClick={joinRoom}>Unirse a la sala</button>
        <button className="btn-secondary" onClick={leaveRoom}>Abandonar la sala</button>
      </div>

      <div className="chat-section">
        <div className="messages" onScroll={ (e) => {
          handleScroll(e);
        }}>
          {messages.map((msg, index) => (
            <div 
              key={index}
              id={`message-${msg._id}`} // ID para identificar mensajes visibles 
              className={msg.type === 'notification' ? 'notification' : 'message'}>
              {msg.type === 'notification' ? (
                <em>{msg.message}</em>
              ) : (
                <div>
                  <b>{msg.user}:</b> {msg.message}
                  <span className="timestamp">{formatDate(msg.timestamp)}</span>
                  {Array.isArray(msg.readBy) && msg.readBy.includes(user) && (
                    <span className='read-indicator'>leído</span>
                  )}
                </div>
              )}
            </div>
          ))}
          {typingUser && <p className="typing">{typingUser} está escribiendo...</p>}
          <div ref={messageEndRef}></div>
        </div>

        <div className="input-section">
          <input
            type="text"
            placeholder="Escribe un mensaje..."
            className="input-field"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              handleTyping();
            }}
            onKeyDown={(e) => {
              handleKeyDown(e);
            }}
          />
          <button className="btn-primary" onClick={sendMessage}>Enviar</button>
        </div>
      </div>
    </div>
  );
}

export default ChaApp;
